<ng-content></ng-content>
<div *ngIf="mobile === false" #containerRef class="slick-date-picker-container" [style.left]="left" [style.top]="top" [style.visibility]="datePickerVisiblity" [style.opacity]="datePickerOpacity">
	<slick-calendar [ngModel]="selectedDate" [condensed]="condensed" (onDateSelect)="onDateSelect($event)"></slick-calendar>
</div>
<div *ngIf="mobile === true" #containerRef class="slick-date-picker-mobile-container" [style.visibility]="datePickerVisiblity" [style.opacity]="datePickerOpacity">
	<div class="slick-date-picker-mobile-calendar">
		<slick-calendar [ngModel]="selectedDate" [condensed]="condensed" (onDateSelect)="onDateSelect($event)"></slick-calendar>
	</div>
</div>
